import { Text } from '@chakra-ui/react';

export const RsvpMessage: React.FC<{ didCurrentUserRsvp: boolean }> = (
  props
) => {
  return (
    <Text>
      {props.didCurrentUserRsvp
        ? 'Thank you for your RSVP!'
        : 'Please RSVP for this event'}
    </Text>
  );
};
